export class Dashboard {
  id: number;
  userId: number = -1;
  slotId1:string='';
  slotId2:string='';
  slotId3:string='';
  slotId4:string='';
  slotId5:string='';
  slotId6:string='';
  active:boolean = false;
  createdAt: string = '';
  updatedAt: string = '';
}
